import React, { useEffect, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import LoginCard from "../User/LoginCard";
import AccountSettings from "../User/AccountSettings";
import AdminBase from "../User/AdminControls/AdminBase";
import LoginGuard from "./LoginGuard";
import Home from "../Home/Home";
import LabReportsHome from "../LabReports/LabReportsHome";
import Analytics from "../Analytics/AnalyticsBase";
import WorkHistoryBase from "../WorkHistory/WorkHistoryBase";
import InspectionForm from "../InspectionForm/InspectionForm2";

interface RouteItem {
    path: string;
    component: React.ComponentType<any>;
    props?: Record<string, any>;
    protected?: boolean;
}

function RoutesComponent() {

    const routes: RouteItem[] = [
        { path: "/login", component: LoginCard, protected: false },
        { path: "/settings", component: AccountSettings, protected: true },
        { path: "/admin", component: AdminBase, protected: true },
        { path: "/verify-email/:token", component: LoginCard, protected: false },
        { path: "/password-reset/:token", component: LoginCard, protected: false },
        { path: "/", component: Home, protected: true },
        { path: "/reports", component: LabReportsHome, protected: true },
        { path: "/analytics", component: Analytics, protected: true },
        { path: "/work-history", component: WorkHistoryBase, protected: true },
        { path: "/inspection-form", component: InspectionForm, protected: true },
        { path: "*", component: LoginCard, protected: false } // catch-all to redirect unknown paths to home
    ];

    return (
        <div>
            <Routes>
                {routes.map(({ path, component: Component, props = {}, protected: isProtected = false }) => (
                    <Route
                        key={path}
                        path={path}
                        element={
                            isProtected ? (
                                <LoginGuard>
                                    <Component {...props} />
                                </LoginGuard>
                            ) : (
                                <Component {...props} />
                            )
                        }
                    />
                ))}
            </Routes>
        </div>
    );
}

export default RoutesComponent;